// GENERATED by scripts/prep-ship-sprites.mjs — do not edit by hand.
// Mast anchor per realistic ship sprite — where the shared ensign overlay
// attaches, normalised to the base sprite (0..1). The renderer sizes the
// ensign itself (uniform world width, see geometry.ts ensignLayout).

export interface FlagAnchor { ax: number; ay: number }

export const FLAG_ANCHOR: Record<string, FlagAnchor> = {
  "armoured-transportship-left": {
    ax: 0.844,
    ay: 0.021
  },
  "armoured-transportship-right": {
    ax: 0.156,
    ay: 0.021
  },
  "battleship-left": {
    ax: 0.496,
    ay: 0.021
  },
  "battleship-right": {
    ax: 0.504,
    ay: 0.021
  },
  "carrier-left": {
    ax: 0.461,
    ay: 0.021
  },
  "carrier-right": {
    ax: 0.539,
    ay: 0.021
  },
  "cruiser-left": {
    ax: 0.463,
    ay: 0.019
  },
  "cruiser-right": {
    ax: 0.537,
    ay: 0.019
  },
  "destroyer-left": {
    ax: 0.463,
    ay: 0.019
  },
  "destroyer-right": {
    ax: 0.537,
    ay: 0.019
  },
  "patrolboat-left": {
    ax: 0.842,
    ay: 0.019
  },
  "patrolboat-right": {
    ax: 0.158,
    ay: 0.019
  },
  "submarine-left": {
    ax: 0.484,
    ay: 0.02
  },
  "submarine-right": {
    ax: 0.516,
    ay: 0.02
  },
  "transportship-left": {
    ax: 0.84,
    ay: 0.03
  },
  "transportship-right": {
    ax: 0.16,
    ay: 0.03
  }
};
